import React, { useEffect, useState } from "react";
import { Space, Radio } from "antd";

import { all as AllStats } from "../../api/Stats";

import SurgicalInterventionTable from "./SurgicalInterventionTable";
import SurgicalInterventionEndedForm from "./SurgicalInterventionEndedForm";
import { getOne as getSurgicalIntervention } from "../../api/SurgicalIntervention";

const TodayTab = (props) => {
  const { selectedDate, careUnitIds } = props;

  const [ready, setReady] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [active, setActive] = useState("all");
  const [surgicalInterventionIds, setSurgicalInterventionIds] = useState({
    current: [],
    start: [],
    end: [],
    expected_end: [],
    current_transfered: [],
    total_end: [],
  });
  const [surgicalInterventionToEdit, setSurgicalInterventionToEdit] = useState(null);

  const onOutFormHandler = () => {
    setShowForm(false);
    props.onChange();
    loadStats(selectedDate);
  };

  const onOutputHandler = (surgicalInterventionId) => {
    setShowForm(true);
    getSurgicalIntervention(surgicalInterventionId).then((data) => {
      setSurgicalInterventionToEdit(data);
    });
  };

  const onChangeHandler = () => {
    loadStats(selectedDate);
    props.onChange();
  };

  const onCloseHandler = () => {
    setShowForm(false);
  };

  /**
   *
   * @param {*} selectedDate
   */
  const loadStats = (selectedDate) => {
    let payload = {};
    if (careUnitIds.length) {
      payload["care_unit_ids"] = careUnitIds;
    }

    AllStats(selectedDate, selectedDate, payload).then((data) => {
      setSurgicalInterventionIds(data["stats"]["sets"][0]);
      setReady(true);
    });
  };

  useEffect(() => {
    loadStats(selectedDate);
  }, [careUnitIds, selectedDate]);

  /**
   * 
   * @returns 
   */
  const getActiveInterventionIds = () => {
    let activeInterventionIds = surgicalInterventionIds[active];

    if (active !== "all") {
      return activeInterventionIds;
    }

    const { current, total_end, end } = surgicalInterventionIds;
    // unconfirmed_out = total_end - end (end confirmées)
    const unconfirmed_end = total_end.filter((item) => !end.includes(item));
    return current.concat(unconfirmed_end);
  }

  return (
    <>
      <Space
        className="mb-4"
        direction="horizontal"
        align="start"
        style={{ width: "100%" }}
      >
        <Radio.Group value={active} onChange={e => setActive(e.target.value)}>
          <Radio value="all">En cours + entrées + retours</Radio>
          <Radio value="start">Entrées du jour</Radio>
          <Radio value="transfers_return">Retours de transfert</Radio>
          <Radio value="total_end">Sorties du jour</Radio>
        </Radio.Group>
      </Space>
      <SurgicalInterventionTable
        {...props}
        ready={ready}
        surgicalInterventionIds={getActiveInterventionIds()}
        transferedSurgicalInterventionIds={surgicalInterventionIds['current_transfered']}
        onOut={onOutputHandler}
        onChange={onChangeHandler}
        mode="out"
      />
      <SurgicalInterventionEndedForm
        onOut={onOutFormHandler}
        onClose={onCloseHandler}
        visible={showForm}
        surgicalIntervention={surgicalInterventionToEdit}
      />
    </>
  );
};

export default TodayTab;
